//import { any, func, string } from 'prop-types';
import React, { useState } from "react";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import { IconButton } from "styled_components/Common/IconButton";

import { ToggleTextButton } from "styled_components/Common/ToggleTextButton";
import { RESOLUTIONS } from "services/config";
import RoleModal from "./RoleModal";
import PasswordModal from "./password/PasswordModal";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const badgeImage = `${CDN_URL}profile/icon-badge.svg`;
const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;

const User = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;

  color: ${(props) => props.theme.Cool_Gray_Med_1};

  .avatar-container {
    min-width: 120px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .image-container {
      width: 72px;
      height: 72px;
      position: relative;

      img {
        width: 72px;
        height: 72px;
      }
      .badge-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    #user-status {
      position: absolute;
      bottom: 8px;
    }
  }
  .main-container {
    min-width: 502px;
    height: 104px;
    background-color: ${(props) => props.theme.componentBackground};

    .header-toggle {
      position: absolute;
      display: flex;
      width: 160px;
      top: -20px;
      right: 1px;
      .option {
        width: 80px;
        height: 20px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        background-color: ${(props) => props.theme.Cool_Gray_Med_2};
        &.selected {
          background-color: ${(props) => props.theme.account};
          color: ${(props) => props.theme.white};
        }
      }
    }
    .dc-details {
      width: 100%;
      height: 100%;
      display: flex;
      position: relative;
      padding: 12px 16px 18px;
      .ver-divider {
        min-width: 2px;
        position: absolute;
        bottom: 9px;
        left: 260px;
        height: 80px;
        border-radius: 15px;
        background-color: ${(props) => props.theme.Cool_Gray_Light_3};
        box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
          1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
      }

      .left-section {
        width: 100%;

        .field {
          width: 232px;
          height: 23px;
          display: flex;
          align-items: center;
          position: relative;
          margin-top: 2px;

          .field-label,
          .field-value {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .field-label {
            min-width: 32px;
            padding-right: 10px;
            color: ${(props) => props.theme.Cool_Gray_Dark_2};
            max-width: 150px;
          }
          .divider {
            width: 100%;
            position: absolute;
            bottom: 0;
            height: 2px;
            border-radius: 15px;
            background-color: ${(props) => props.theme.Cool_Gray_Light_3};
            box-shadow: -1px -1px 1.5px ${(props) =>
                  props.theme.Cool_Gray_Light_3} inset,
              1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
          }
        }
      }
      .right-section {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .badge-section {
          position: absolute;
          right: 22px;
          top: 5px;
          width: 160px;
          height: 72px;
          border-radius: 4px;
          border: none;
          text-align: center;
          outline: none !important;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .icon {
            cursor: pointer;
          }
          #view-badges {
            margin-bottom: 10px;
          }
          .add-access {
            .field-label {
              cursor: pointer;
              text-decoration: underline;
            }
          }
          .add-access:hover {
            color: ${(props) => props.theme.DCBLOX_Gray};
          }
          .field {
            width: 104px;
            height: 30px;
            display: flex;
            align-items: center;
            position: relative;

            .field-label,
            .field-value {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .field-label {
              min-width: 32px;
              padding-right: 10px;
              color: ${(props) => props.theme.Cool_Gray_Dark_2};
              max-width: 150px;
            }
            .divider {
              width: 100%;
              position: absolute;
              bottom: 0;
              height: 2px;
              border-radius: 15px;
              background-color: ${(props) => props.theme.Cool_Gray_Light_3};
              box-shadow: -1px -1px 1.5px ${(props) =>
                    props.theme.Cool_Gray_Light_3} inset,
                1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
            }
          }
        }
      }
    }
    .top-row {
      padding-top: 10px;
    }

    .top-row,
    .bottom-row {
      width: 100%;
      height: 50%;
      display: flex;
      position: relative;

      .field {
        width: 100%;
        height: 25px;
        margin-top: 8px;
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 12px;

        .field-label,
        .field-value {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .field-label {
          min-width: 32px;
          padding-right: 10px;
          color: ${(props) => props.theme.Cool_Gray_Dark_2};
          max-width: 230px;
        }
        .divider {
          width: 80%;
          position: absolute;
          bottom: 0;
          height: 2px;
          border-radius: 15px;
          background-color: ${(props) => props.theme.Cool_Gray_Light_3};
          box-shadow: -1px -1px 1.5px ${(props) =>
                props.theme.Cool_Gray_Light_3} inset,
            1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
        }

        .field-value {
          max-width: 200px;
        }

        .action-button {
          margin-left: 1rem;
          margin-bottom: 0.5rem;
        }
      }
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    .avatar-container {
      min-width: 144px;

      .image-container {
        width: 96px;
        height: 96px;

        img {
          width: 96px;
          height: 96px;
        }
        .user-enabled {
          height: 24px;
        }
        .badge-icon {
          position: absolute;
          top: 0px;
          right: 0px;
          img {
            width: 25px;
            height: 25px;
          }
        }
      }
      #user-status {
        bottom: 8px;
      }
    }
    .main-container {
      width: 782px;
      height: 128px;
      .header-toggle {
        top: -32px;
        right: 0px;
        width: 200px;
        .option {
          width: 100px;
          height: 32px;
        }
      }
      .dc-details {
        .ver-divider {
          min-width: 2px;
          position: absolute;
          bottom: 12px;
          left: 280px;
          height: 100px;
        }

        .left-section {
          .field {
            width: 232px;
            height: 26px;
            margin-top: 2px;

            .field-label {
              height: 16px;
              min-width: 32px;
              padding-right: 20px;
              color: ${(props) => props.theme.Cool_Gray_Dark_2};
            }
            .divider {
              width: 100%;
              position: absolute;
              bottom: 0;
              height: 2px;
              border-radius: 15px;
              background-color: ${(props) => props.theme.Cool_Gray_Light_3};
              box-shadow: -1px -1px 1.5px ${(props) =>
                    props.theme.Cool_Gray_Light_3} inset,
                1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
            }
          }
        }
        .right-section {
          .badge-section {
            position: absolute;
            right: 8px;
            top: 7px;
            width: 260px;
            height: 92px;

            .field {
              width: 154px;
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;

              .field-label {
                min-width: 52px;
                padding-right: 10px;
                color: ${(props) => props.theme.Cool_Gray_Dark_2};
              }
            }
          }
        }
      }
      .top-row {
        padding-left: 20px;
        padding-top: 16px;
      }
      .bottom-row {
        padding-left: 20px;
        padding-top: 0px;
      }

      .top-row,
      .bottom-row {
        .field {
          .field-label {
            min-width: 32px;
            padding-right: 10px;
          }
        }
        .divider {
          height: 2px;
          border-radius: 15px;
          background-color: ${(props) => props.theme.Cool_Gray_Light_3};
          box-shadow: -1px -1px 1.5px ${(props) =>
                props.theme.Cool_Gray_Light_3} inset,
            1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
        }
        .action-button {
          margin-left: 2rem !important;
          margin-top: -0.5rem;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    &::before {
      height: 450px;
      width: 650px;
    }
    &.active {
      transition-delay: 0.3s;

      &::before {
        animation: diagonal-swipe 0.6s ease forwards;
        transition-delay: 0.3s;
      }
    }

    .avatar-container {
      min-width: 208px;

      .image-container {
        width: 128px;
        height: 128px;

        img {
          width: 128px;
          height: 128px;
        }
        .user-enabled {
          height: 34px;
        }
        .badge-icon {
          position: absolute;
          top: 0px;
          right: 0px;
          img {
            width: 25px;
            height: 25px;
          }
        }
      }
      #user-status {
        bottom: 50px;
      }
    }
    .main-container {
      width: 1140px;
      height: 232px;

      .header-toggle {
        position: absolute;
        display: flex;
        width: 250px;
        top: -40px;
        right: 0px;
        .option {
          width: 125px;
          height: 40px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          background-color: ${(props) => props.theme.Cool_Gray_Light_1};
          &.selected {
            background-color: ${(props) => props.theme.account};
            color: ${(props) => props.theme.white};
            box-shadow: 2px 2px 5px 0 ${(props) => props.theme.boxShadow};
          }
        }
      }
      .dc-details {
        padding: 40px 40px 18px;
        .ver-divider {
          min-width: 2px;
          position: absolute;
          bottom: 25px;
          left: 430px;
          height: 180px;
          border-radius: 15px;
          background-color: ${(props) => props.theme.Cool_Gray_Light_3};
          box-shadow: -1px -1px 1.5px ${(props) =>
                props.theme.Cool_Gray_Light_3} inset,
            1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
        }

        .left-section {
          width: 100%;

          .field {
            width: 332px;
            height: 43px;
            display: flex;
            align-items: center;
            position: relative;
            margin-top: 4px;

            .field-label {
              height: 16px;
              min-width: 32px;
              padding-right: 20px;
              color: ${(props) => props.theme.Cool_Gray_Dark_2};
            }
            .divider {
              width: 100%;
              position: absolute;
              bottom: 0;
              height: 2px;
              border-radius: 15px;
              background-color: ${(props) => props.theme.Cool_Gray_Light_3};
              box-shadow: -1px -1px 1.5px ${(props) =>
                    props.theme.Cool_Gray_Light_3} inset,
                1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
            }
          }
        }
        .right-section {
          .badge-section {
            width: 400px;
            height: 172px;
            top: -8px;
            right: 50px;
            .field {
              width: 300px;
              height: 50px;
              display: flex;
              align-items: center;
              position: relative;

              .field-label {
                min-width: 72px;
                padding-right: 20px;
                color: ${(props) => props.theme.Cool_Gray_Dark_2};
              }
              .divider {
                width: 100%;
                position: absolute;
                bottom: 0;
                height: 2px;
                border-radius: 15px;
                background-color: ${(props) => props.theme.Cool_Gray_Light_3};
                box-shadow: -1px -1px 1.5px ${(props) =>
                      props.theme.Cool_Gray_Light_3} inset,
                  1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
              }
            }
          }
        }
      }
      .top-row {
        padding-left: 40px;
        padding-top: 45px;
      }
      .bottom-row {
        padding-left: 40px;
        padding-top: 0px;
      }
      .top-row,
      .bottom-row {
        .field {
          .field-label {
            min-width: 52px;
            padding-right: 30px;
          }
          .divider {
            min-height: 2px;
            border-radius: 15px;
            background-color: ${(props) => props.theme.Cool_Gray_Light_3};
            box-shadow: -1px -1px 1.5px ${(props) =>
                  props.theme.Cool_Gray_Light_3} inset,
              1px 1px 1.5px ${(props) => props.theme.boxShadow} inset;
          }

          .field-label {
            max-width: 430px;
          }

          .action-button {
            margin-left: 6rem !important;
            margin-top: -1rem;
          }
        }
      }
    }
  }
`;

export const UserDetails = ({
  className,
  id,
  onClick,
  onMouseOver,
  module,
  image,
  user,
  fields,
  showToggle,
  selectedToggle,
  switchToggle,
  modalToggle,
  rosterUser,
  hasEditUserStatusAccess,
  hasEditRosterUserAccess,
  addDataCenter,
  breakpoint,
  owners,
  updateUserRole,
  updateUserPassword,
  editRole,
  isUserManagement,
}) => {
  const topFields = fields?.top;
  const bottomFields = fields?.bottom;
  const leftFields = fields?.left;
  const rightFields = fields?.right;
  const isSharedUser = user?.userProfile?.sharedUser;
  const datacenters = rosterUser?.datacenterList;
  const [showModal, setShowModal] = useState(false);
  const [showModalPassword, setShowModalPassword] = useState(false);
  function getSize(breakpoint) {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }
    return size;
  }

  function toggleModal() {
    setShowModal(!showModal);
    if (showModal) {
      const iconButton = document.getElementById("icon-button");
      setTimeout(() => iconButton.classList.remove("active"), 2000);
    }
  }

  function toggleModalPassword() {
    setShowModalPassword(!showModalPassword);
    if (showModalPassword) {
      const iconButton = document.getElementById("icon-button-password");
      setTimeout(() => iconButton.classList.remove("active"), 2000);
    }
  }

  return (
    <User
      id={id}
      className={`${className} user-details`}
      onMouseOver={onMouseOver}
      module={module}
    >
      <div className="avatar-container">
        <div className="image-container">
          <img src={image} />
          {datacenters && datacenters?.length !== 0 && (
            <div className="badge-icon">
              <img src={badgeImage} />
            </div>
          )}
        </div>
        {onClick && hasEditUserStatusAccess && (
          <ToggleTextButton
            onClick={onClick}
            enabled={JSON.parse(user?.enabled)}
          />
        )}
      </div>
      <div className="main-container">
        {showToggle && (
          <div className="header-toggle">
            <div
              className={
                selectedToggle === "portal"
                  ? "option selected blox-button"
                  : "option blox-button"
              }
              onClick={() => switchToggle("portal")}
              data-cy="portal-toggle"
            >
              <div className="title">PORTAL</div>
            </div>
            <div
              className={
                selectedToggle === "dc"
                  ? "option selected blox-button"
                  : "option blox-button"
              }
              onClick={() => switchToggle("dc")}
              data-cy="dc-toggle"
            >
              <div className="title"> DATA CENTER</div>
            </div>
          </div>
        )}
        {selectedToggle === "portal" && (
          <>
            <div className="top-row">
              {topFields &&
                topFields.map((field) => (
                  <div className="field">
                    {isUserManagement && isSharedUser && field?.value === "" ? (
                      <>
                        <div className="field-label labels21">
                          Change Shared Password
                        </div>
                        <IconButton
                          enabled={true}
                          id="icon-button-password"
                          module={"account"}
                          onClick={toggleModalPassword}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={EditIconDefault}
                            alt="edit-icon-password"
                            onClick={toggleModalPassword}
                          />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <div className="field-label labels21">
                          {field?.label}
                        </div>
                        <div className="field-value body10">{field?.value}</div>
                      </>
                    )}
                    <span className="divider"></span>
                  </div>
                ))}
            </div>
            <div className="bottom-row">
              {bottomFields &&
                bottomFields.map((field) => (
                  <div className="field">
                    <div className="field-label labels21">{field?.label}</div>
                    <div className="field-value body10">{field?.value}</div>
                    {field?.label === "Role" && editRole && (
                      <IconButton
                        enabled={true}
                        id="icon-button-role"
                        module={"account"}
                        onClick={toggleModal}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={EditIconDefault}
                          alt="edit-icon"
                          onClick={toggleModal}
                        />
                      </IconButton>
                    )}
                    <span className="divider"></span>
                  </div>
                ))}
            </div>
          </>
        )}
        {selectedToggle === "dc" && (
          <div className="dc-details">
            <div className="left-section">
              {leftFields &&
                leftFields.map((field) => (
                  <div className="field">
                    <div className="field-label labels21">{field?.label}</div>
                    <div className="field-value body10">{field?.value}</div>
                    <span className="divider"></span>
                  </div>
                ))}
            </div>
            <div className="ver-divider"></div>
            <div className="right-section">
              {rightFields && (
                <div className="badge-section">
                  {rightFields.map((field) => (
                    <div className="field">
                      <div className="field-label labels21">{field?.label}</div>
                      <div className="field-label body10">{field?.value}</div>
                      <span className="divider"></span>
                    </div>
                  ))}
                  {rosterUser && rosterUser?.id && (
                    <BloxButton
                      className="buttons41"
                      id="view-badges"
                      text="VIEW BADGES"
                      module="account"
                      enabled={true}
                      onClick={() => {
                        modalToggle();
                      }}
                      cypressId="badge-modal-button"
                    />
                  )}
                  {hasEditRosterUserAccess && (
                    <BloxButton
                      className="buttons41"
                      text="ADD ACCESS"
                      enabled={true}
                      id="add-datacenter-button"
                      module="account"
                      cypressId="add-datacenter-button"
                      onClick={() => {
                        addDataCenter();
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <RoleModal
        show={showModal}
        closeModal={toggleModal}
        user={user}
        owners={owners}
        updateUserRole={updateUserRole}
        breakpoint={breakpoint}
        getSize={getSize}
      />
      <PasswordModal
        show={showModalPassword}
        closeModal={toggleModalPassword}
        user={user}
        updateUserPassword={updateUserPassword}
        breakpoint={breakpoint}
        getSize={getSize}
      />
    </User>
  );
};
